import { graphql } from 'react-relay';
import callMutation from 'shared/relay/mutations/call-mutation';

export default function confirmOriginalAddressMutation(
  packageId,
  isAddressCorrect,
  callbacks
) {
  const mutation = graphql`
    mutation confirmOriginalAddressMutation(
      $input: PackageTrackerAddressConfirmationMutationInput!
    ) {
      packageTrackerAddressConfirmation(input: $input) {
        success
      }
    }
  `;

  const variables = {
    input: {
      packageId,
      isAddressCorrect
    }
  };

  return callMutation(mutation, variables, callbacks);
}
